// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed6810eb","453":"dc473386","455":"a14a0d59","977":"569edb40"}[chunkId] + ".chunk.js";
};